/**
 * P3-36: SpaceProgramBtn —— 太空任务按钮（迁移自 SpaceProgramBtnController）。
 */
import type { GamePage } from "../../bridge/GameBridge";
import type { BuildingBtnControllerLike } from "../bonfire/BuildingBtn";
import { SpaceBuildingBtn } from "./SpaceBuildingBtn";

export interface SpaceProgramBtnProps {
  programName: string;
}

function getController():
  | (new (game: GamePage) => BuildingBtnControllerLike)
  | undefined {
  const w = window as unknown as {
    com?: {
      nuclearunicorn?: {
        game?: {
          ui?: {
            SpaceProgramBtnController?: new (
              game: GamePage,
            ) => BuildingBtnControllerLike;
          };
        };
      };
    };
  };
  return w.com?.nuclearunicorn?.game?.ui?.SpaceProgramBtnController;
}

export function SpaceProgramBtn({ programName }: SpaceProgramBtnProps) {
  return (
    <SpaceBuildingBtn
      id={programName}
      name={programName}
      description=""
      getController={getController}
      type="spaceMission"
    />
  );
}
